import { useTranslation } from 'react-i18next'

import { FloatingTooltip } from '../../Floating'
import { ICON_COLOR, ICON_HEIGHT_24, IconNG } from '../../Icon'

import * as styles from './EntityArchivedIcon.module.css'

import ArchiveIcon from '../../../icons/archive.svg'

function EntityArchivedIcon({
  Icon = ArchiveIcon,
  color = ICON_COLOR.Red,
  containerClassName = styles.entityArchivedIconContainer,
  size = ICON_HEIGHT_24,
  tooltip = 'Common.EntityArchivedIconTooltipKey',
}) {
  const { t } = useTranslation()

  return (
    <FloatingTooltip content={tooltip ? t(tooltip) : null} disabled={!tooltip}>
      <IconNG
        Icon={Icon}
        className={containerClassName}
        color={color}
        size={size}
      />
    </FloatingTooltip>
  )
}

export default EntityArchivedIcon
